import React from "react";
import { Helmet } from "react-helmet-async";
import { injectIntl, IntlShape } from "react-intl";
import { withOneColLayout } from "../../../../utils";
import PageSubheader from "../../../../components/PageSubheader";
import PriceUnitVariationForm from "../form";

interface Props {
  intl: IntlShape;
  backURL: string;
}

const CreatePriceUnitVariation = (props: Props) => {
  const { intl, backURL } = props;

  return (
    <>
      <Helmet>
        <title>
          {intl.formatMessage({
            id: "page.price.unit.variation.create.document.title",
          })}
        </title>
      </Helmet>

      <PageSubheader
        goBackEnabled
        goBackId="btn-back-price-unit-variation-create"
        goBackURL={backURL}
      />

      <PriceUnitVariationForm {...props} edition={false} />
    </>
  );
};

export default withOneColLayout(injectIntl(CreatePriceUnitVariation));
